import { c as _c } from "react/compiler-runtime";
import { BottomSheet } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import type { DeviceInfo } from '@/idv2/hooks';
export type MissingPermissionsSheetProps = {
  device: DeviceInfo;
  open: boolean;
  onClose?: () => void;
};
const MissingPermissionsSheet = t0 => {
  const $ = _c(26);
  const {
    device,
    open,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.components.missing-permissions"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  const {
    osName,
    type: deviceType,
    browser
  } = device;
  let t2;
  if ($[1] !== browser || $[2] !== deviceType || $[3] !== osName || $[4] !== t) {
    t2 = () => {
      if (browser.includes("Safari")) {
        return t(_temp);
      }
      if (deviceType === "mobile") {
        if (osName === "iOS") {
          return t(_temp2);
        }
        if (osName === "Android") {
          return t(_temp3);
        }
        return t(_temp4);
      }
      return t(_temp5);
    };
    $[1] = browser;
    $[2] = deviceType;
    $[3] = osName;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const getTranslation = t2;
  let t3;
  if ($[6] !== t) {
    t3 = t(_temp6);
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <h2 className="text-heading-3 text-primary">{t3}</h2>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t(_temp7);
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <p className="text-body-2 text-secondary">{t5}</p>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== getTranslation) {
    t7 = getTranslation();
    $[14] = getTranslation;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <p className="text-body-2 text-primary mt-10 text-center fp-text">{t7}</p>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t4 || $[19] !== t6 || $[20] !== t8) {
    t9 = <div className="mt-4 mb-10 flex flex-col items-center gap-2 text-center">{t4}{t6}{t8}</div>;
    $[18] = t4;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== onClose || $[23] !== open || $[24] !== t9) {
    t10 = <BottomSheet open={open} onClose={onClose}>{t9}</BottomSheet>;
    $[22] = onClose;
    $[23] = open;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};
export default MissingPermissionsSheet;
function _temp($) {
  return $["cta-safari"];
}
function _temp2($_0) {
  return $_0["cta-ios"];
}
function _temp3($_1) {
  return $_1["cta-android"];
}
function _temp4($_2) {
  return $_2["cta-mobile"];
}
function _temp5($_3) {
  return $_3["cta-desktop"];
}
function _temp6($_4) {
  return $_4.title;
}
function _temp7($_5) {
  return $_5.subtitle;
}